export default __webpack_public_path__ + "static/form-grouping-dont-3d9e15ef4482a43560b88cad37046fa0.png";